// A short "ding" alert (two quick beeps) synthesized with the Web Audio API —
// no audio file needed. Used to alert a doctor when reception adds a new patient
// to their queue.
//
// Browsers start an AudioContext "suspended" until a user gesture, so we lazily
// create it and resume it on the first interaction (click / key / touch). After
// the doctor has interacted with the page once, the ding plays on its own.

let _ctx = null;

function ctx() {
  if (_ctx) return _ctx;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    _ctx = new AC();
  } catch {
    return null;
  }
  return _ctx;
}

function unlock() {
  const c = ctx();
  if (c && c.state === "suspended") c.resume().catch(() => {});
}

if (typeof window !== "undefined") {
  ["click", "keydown", "touchstart"].forEach((ev) =>
    window.addEventListener(ev, unlock, { passive: true })
  );
}

function beep(c, startAt, freq = 880, dur = 0.15) {
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  osc.connect(gain);
  gain.connect(c.destination);
  // Quick attack then exponential decay so it sounds like a bell "ding".
  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(0.35, startAt + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + dur);
  osc.start(startAt);
  osc.stop(startAt + dur + 0.02);
}

/** Play the ding `times` times in quick succession (default 2). */
export function playDing(times = 2) {
  const c = ctx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  const gap = 0.3;
  const t0 = c.currentTime + 0.02;
  for (let i = 0; i < times; i++) beep(c, t0 + i * gap);
}
